import React, { useEffect, useRef, useState } from 'react'
import { SendIcon } from './icons'

type ChatComposerProps = {
  placeholder: string
  sendLabel: string
  disabled?: boolean
  autoFocus?: boolean
  onSend: (text: string) => void
}

const MAX_LEN = 4000

export const ChatComposer: React.FC<ChatComposerProps> = ({
  placeholder,
  sendLabel,
  disabled = false,
  autoFocus = false,
  onSend,
}) => {
  const [draft, setDraft] = useState('')
  const ref = useRef<HTMLTextAreaElement>(null)

  // Auto-grow up to the CSS max-height.
  const grow = () => {
    const el = ref.current
    if (!el) return
    el.style.height = 'auto'
    el.style.height = `${el.scrollHeight}px`
  }
  useEffect(grow, [draft])
  useEffect(() => {
    if (autoFocus) ref.current?.focus()
  }, [autoFocus])

  const canSend = draft.trim().length > 0 && !disabled

  const submit = () => {
    if (!canSend) return
    onSend(draft.trim())
    setDraft('')
    ref.current?.focus()
  }

  return (
    <div className="wc-composer">
      <textarea
        ref={ref}
        className="wc-textarea"
        rows={1}
        maxLength={MAX_LEN}
        value={draft}
        placeholder={placeholder}
        disabled={disabled}
        onChange={(e) => setDraft(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault()
            submit()
          }
        }}
      />
      <button
        type="button"
        className="wc-send"
        aria-label={sendLabel}
        disabled={!canSend}
        onClick={submit}
      >
        <SendIcon />
      </button>
    </div>
  )
}
